export const FooterLink2 = [
  {
    title: "Subjects",
    links: [
      { title: "AI", link: "catalog/ai" },
      { title: "Cloud Computing", link: "catalog/cloud-computing" },
      { title: "Code Foundations", link: "catalog/code-foundations" },
      { title: "Computer Science", link: "catalog/computer-science" },
      { title: "Cybersecurity", link: "catalog/cybersecurity" },
      { title: "Data Analytics", link: "catalog/data-analytics" },
      { title: "Data Science", link: "catalog/data-science" },
      { title: "Data Visualization", link: "catalog/data-visualization" },
      { title: "Developer Tools", link: "catalog/developer-tools" },
      { title: "DevOps", link: "catalog/devops" },
      { title: "Game Development", link: "catalog/game-development" },
      { title: "IT", link: "catalog/it" },
      { title: "ML", link: "catalog/machine-learning" },
      { title: "Math", link: "catalog/math" },
      { title: "Mobile Development", link: "catalog/mobile-development" },
      { title: "Web Design", link: "catalog/web-design" },
      { title: "Web Development", link: "catalog/web-development" },
    ],
  },
  {
    title: "Languages",
    links: [
      { title: "Bash", link: "catalog/bash" },
      { title: "C++", link: "catalog/c++" },
      { title: "C#", link: "catalog/csharp" },
      { title: "Go", link: "catalog/go" },
      { title: "HTML & CSS", link: "catalog/html-&-css" },
      { title: "Java", link: "catalog/java" },
      { title: "JavaScript", link: "catalog/javascript" },
      { title: "Kotlin", link: "catalog/kotlin" },
      { title: "PHP", link: "catalog/php" },
      { title: "Python", link: "catalog/python" },
      { title: "R", link: "catalog/r" },
      { title: "Ruby", link: "catalog/ruby" },
      { title: "SQL", link: "catalog/sql" },
      { title: "Swift", link: "catalog/swift" },
    ],
  },
  {
    title: "Career building",
    links: [
        {title: "Career paths", link: "career-paths"},
        {title: "Career services", link: "career-services"},
        {title: "Interview prep", link: "interview-prep"},
        {title: "Professional certification", link: "professional-certification"},
        {title: "-", link: "/hi"},
        {title: "Full Catalog", link: "full-catalog"},
        {title: "Beta Content", link: "beta-content"}
    ]
  }
];
